<script>
  import lodash from 'lodash';
  import TableCellBase from './TableCellBase.vue';

  export default {
    name: 'TableCellNumTestsPerPhysician',
    extends: TableCellBase,
    data() {
      return {
        fields: [
          'tests_ige',
          'tests_mqt',
          'tests_pricks',
          'tests_sticks',
        ],
      };
    },
    computed: {
      actualTestsRaw() {
        return lodash.reduce(this.fields, (sum, field) => {
          return sum + parseInt(this.monthObj[field])
        }, 0);
      },
      actualValueRaw() {
        return this.round(this.getRatio(this.actualTestsRaw, this.monthObj['num_physicians_and_midlevel']), 2);
      },
    },
  };
</script>
